import { RESET_STATE } from 'store/global/actions';

import { LOAN_HEADER_VIEW_ACTION_TYPE } from '../actions';

const initialState = null;

const resolvedSubCompanyHeaderViewReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOAN_HEADER_VIEW_ACTION_TYPE.GET_RESOLVED_SUB_COMPANY_HEADER_VIEW:
      return payload ?? initialState;
    case RESET_STATE:
      return initialState;
    default:
      return state;
  }
};

export default resolvedSubCompanyHeaderViewReducer;
